import { render, staticRenderFns } from "./AgendaDayGrigliaComponent.vue?vue&type=template&id=0cd322bb&scoped=true"
import script from "./AgendaDayGrigliaComponent.vue?vue&type=script&lang=js"
export * from "./AgendaDayGrigliaComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaDayGrigliaComponent.vue?vue&type=style&index=0&id=0cd322bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd322bb",
  null
  
)

export default component.exports